<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    :largura="500"
    @click:primary="gerarRelatorio"
  >
    <SysGrupoAutocomplete
      v-model="filtros.grupos"
      label="Grupos"
      outlined
      multiple
      hide-details
    />

    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      label="Segmentos"
      outlined
      multiple
      hide-details
      class="mt-4"
    />

    <SysCompradorAutocomplete
      v-model="filtros.compradores"
      label="Compradores"
      outlined
      multiple
      :qtde_visivel_selecionados="1"
      :ids-segmento="filtros.segmentos"
      :ids-grupo="filtros.grupos"
      hide-details
      class="mt-4"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :qtdeVisivelSelecionados="1"
      :ids-segmento="filtros.segmentos"
      hide-details
      class="mt-4"
    />

    <SysSecaoAutocomplete
      v-model="filtros.secoes"
      label="Seções"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      :ids-grupo="filtros.grupos"
      hide-details
      class="mt-4"
    />

    <SysCategoriaAutocomplete
      v-model="filtros.categorias"
      label="Categorias"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      :ids-grupo="filtros.grupos"
      hide-details
      class="mt-4"
    />

    <form
      :action="URL_RELATORIO"
      method="post"
      target="_blank"
      ref="submit-form-relatorio-sugestao-categorias"
    >
      <input type="text" hidden name="filtros" :value="JSON.stringify(filtros)" />
    </form>
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import $axios from "@/api/api";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete.vue";
import SysSecaoAutocomplete from "@/components/utils/crud/SysSecaoAutocomplete.vue";
import SysCategoriaAutocomplete from "@/components/utils/crud/SysCategoriaAutocomplete.vue";

export default {
  name: "ComparacaoDeEstoques",
  mixins: [Mixin],
  components: {
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysGrupoAutocomplete,
    SysCompradorAutocomplete,
    SysSecaoAutocomplete,
    SysCategoriaAutocomplete
  },
  data: () => ({
    filtros: {
      grupos: [],
      segmentos: [],
      compradores: [],
      fornecedores: [],
      secoes: [],
      categorias: []
    }
  }),
  computed: {
    GET_BASE_URL() {
      if (window.__APP_CONFIG__.VUE_APP_MULTI_DATABASE === "true" || window.__APP_CONFIG__.VUE_APP_MULTIPLAS_BASE_URL === "true") {
        return localStorage.baseUrl||window.__APP_CONFIG__.VUE_APP_URL_BASE;
      }

      return window.__APP_CONFIG__.VUE_APP_URL_BASE;
    },
    URL_RELATORIO() {
      return this.GET_BASE_URL + '/api/' + this.relatorio.url;
    }
  },
  methods: {
    gerarRelatorio() {
      this.$refs['submit-form-relatorio-sugestao-categorias'].submit();
      this.DIALOG_ATIVO = false;
    }
  }
  // methods: {
  //   gerarRelatorio() {
  //     const url = `${this.relatorio.url}${this.Helpers.formatarParametrosObjParaUrl(this.filtros)}`;
  //     window.open(`${$axios.defaults.baseURL}/${url}`, "_blank");
  //     this.DIALOG_ATIVO = false;
  //   }
  // }
}
</script>

<style scoped>

</style>
